import { memo } from 'react';

import TinderIcon from 'Assets/reactSvgs/TinderIcon';
import TinderUIcon from 'Assets/reactSvgs/TinderUIcon';

type Props = React.ComponentProps<typeof TinderIcon> & {
  isTinderU?: boolean;
};

const BrandLogo = (props: Props) => {
  const { isTinderU = false, ...restProps } = props;
  const Icon = isTinderU ? TinderUIcon : TinderIcon;
  return <Icon {...restProps} />;
};

export default memo(BrandLogo);
